export default {"src":"/_next/static/media/icon_i.09024bce.svg","height":45,"width":45,"blurWidth":0,"blurHeight":0};